import React from "react";

export const Spinner = ({ className = "w-6 h-6", color = "border-navy" }) => {
  return (
    <div
      className={`inline-block border-3 ${color} border-t-transparent rounded-full animate-spin shrink-0 ${className}`}
      role="status"
      aria-label="loading"
    />
  );
};

export default Spinner;
